import ConfigurationCreate from './ConfigurationCreate';
import ConfigurationShow from './ConfigurationShow';
import ConfigurationEdit from './ConfigurationEdit';

export default {
  create: ConfigurationCreate,
  show: ConfigurationShow,
  edit: ConfigurationEdit,
};
